import SearchApiService from "@/services/SearchApiService.js";

import { ref, reactive, toRefs, watch, nextTick } from "vue";
import { useRoute, onBeforeRouteLeave } from "vue-router";
import store from "@/store";

export const useAllSearch = () => {
    const route = useRoute();

    // ページ離脱時にスクロール位置を保存（クリック時の正確な位置を取得）
    onBeforeRouteLeave(() => {
        const params = store.state.params;
        if (params && Object.keys(params).length > 0) {
            store.commit("setParams", { ...params, scrollY: window.scrollY });
        }
    });
    // 検索条件のデフォルト値をセットする。form_typeはここでは不変のためセットしない。
    const paramDefaults = {
        keyword: "",
        target_range: ["paper", "noukigu"],
        sort: "created",
        per_page: 20,
        page: 1,
        dbname: [],
        catyear: [],
    };
    // 検索条件を格納する
    const searchCondition = reactive({
        form: {
            keyword: "",
            target_range: paramDefaults.target_range,
            form_type: "all_detail",
            dbname: paramDefaults.dbname,
            catyear: paramDefaults.catyear,
        },
        sort: paramDefaults.sort,
        per_page: paramDefaults.per_page,
        page: paramDefaults.page,
    });
    // バリデーション結果を格納する
    const formRef = ref(null);
    // 検索結果を格納する
    const apiresult = reactive({
        hits: 0,
        results: [],
    });
    const searchError = ref(false);
    const searchLoad = ref(false);
    // 検索結果部分を表示するか否か
    const showResult = ref(false);
    //ファセット表示のリセットフラグ
    const facetResetFlg = ref(false);

    const database_name = {
        paper: "論文",
        noukigu: "農機具",
    };

    // facet表示用
    const facetDatabase = reactive({
        facetName: "データベース",
        facetResults: {},
        showFacetCancel: false, // Facetによる絞り込み解除を表示するか否か
        facetError: false,
        facetLoading: false,
    });
    const facetCatyear = reactive({
        facetName: "発行年等",
        facetResults: {},
        showFacetCancel: false, // Facetによる絞り込み解除を表示するか否か
        facetError: false,
        facetLoading: false,
    });

    //検索対象表示項目
    const searchInfoItems = ref([]);
    const searchParams = ref({});

    /* method */
    //検索条件の入力内容をクリアする
    //入力項目以外は設定そのままとする
    const resetForm = async () => {
        for (const [key, value] of Object.entries(paramDefaults)) {
            if (
                key == "sort" ||
                key == "per_page" ||
                key == "page" ||
                key == "dbname" ||
                key == "catyear"
            ) {
                continue;
            }
            searchCondition.form[key] = value;
        }
    };

    // すべて検索用
    const search = async () => {
        //検索対象部分に表示する内容を格納
        //チェックボックス関連の表示メッセージ作成
        let database_disp = "";
        for (let i = 0; i < searchCondition.form.target_range.length; i++) {
            if (i > 0) {
                database_disp += " OR ";
            }
            database_disp +=
                database_name[searchCondition.form.target_range[i]];
        }
        searchInfoItems.value = [
            {
                entitle: "キーワード",
                value: String(searchCondition.form.keyword),
            },
            {
                entitle: "DB選択",
                value: database_disp,
            },
            {
                entitle: "検索種別",
                value: "詳細検索",
            },
            {
                entitle: "発行年等で絞り込み",
                value: String(searchCondition.form.catyear),
            },
            {
                entitle: "データベースで絞り込み",
                value: String(searchCondition.form.dbname),
            },
        ];

        // 表示用
        showResult.value = true;

        let paramsData = {};
        paramsData.params = {};
        searchParams.value = {};
        Object.entries(searchCondition.form).forEach(([key, value]) => {
            if (typeof value == "object") {
                if (value != null && value.length > 0) {
                    paramsData.params[key] = value;
                    searchParams.value[key] = value;
                }
            } else {
                if (value != null && value != "") {
                    paramsData.params[key] = value;
                    searchParams.value[key] = value;
                }
            }
        });
        paramsData.params["sort"] = searchCondition.sort;
        paramsData.params["per_page"] = searchCondition.per_page;
        paramsData.params["page"] = searchCondition.page;

        searchParams.value["sort"] = searchCondition.sort;
        searchParams.value["per_page"] = searchCondition.per_page;
        searchParams.value["page"] = searchCondition.page;
        searchParams.value["url_name"] = "Top";

        searchLoad.value = true;
        searchError.value = false;
        apiresult.results = [];
        const res = await SearchApiService.getAllResults(paramsData);
        if (res) {
            if (res.status == 204) {
                apiresult.hits = 0;
                apiresult.results = [];
            } else {
                apiresult.hits = res.data.response.hits;
                apiresult.results = res.data.response.results;
            }
            searchError.value = false;
        } else {
            searchError.value = true;
        }
        searchLoad.value = false;
        facetResetFlg.value = true;
    };
    // ファセット検索用。ファセットのデータを取得する。
    const execFacetApi = async (facettype) => {
        const paramsFacet = {
            facet: facettype,
            max: 100,
            sort: searchCondition.sort,
        };
        Object.entries(searchCondition.form).forEach(([key, value]) => {
            if (typeof value == "object") {
                if (value != null && value.length > 0) {
                    paramsFacet[key] = value;
                }
            } else {
                if (value != null && value != "") {
                    paramsFacet[key] = value;
                }
            }
        });
        let paramsData1 = {};
        paramsData1.params = {};
        let paramsData2 = {};
        paramsData2.params = {};
        switch (facettype) {
            case String("dbname"): {
                Object.entries(paramsFacet).forEach(([key, value]) => {
                    paramsData1.params[key] = value;
                });
                facetDatabase.facetError = false;
                facetDatabase.facetLoading = true;
                const res1 = await SearchApiService.getAllFacet(paramsData1);
                facetDatabase.facetLoading = false;
                if (res1) {
                    if (res1.status == 204) {
                        facetDatabase.facetResults = {};
                    } else {
                        facetDatabase.facetResults = res1.data.response;
                    }
                    facetDatabase.facetError = false;
                } else {
                    facetDatabase.facetResults = {};
                    facetDatabase.facetError = true;
                }
                break;
            }
            case String("catyear"): {
                Object.entries(paramsFacet).forEach(([key, value]) => {
                    paramsData2.params[key] = value;
                });
                facetCatyear.facetError = false;
                facetCatyear.facetLoading = true;
                const res2 = await SearchApiService.getAllFacet(paramsData2);
                facetCatyear.facetLoading = false;
                if (res2) {
                    if (res2.status == 204) {
                        facetCatyear.facetResults = {};
                    } else {
                        facetCatyear.facetResults = res2.data.response;
                    }
                    facetCatyear.facetError = false;
                } else {
                    facetCatyear.facetResults = {};
                    facetCatyear.facetError = true;
                }
                break;
            }
        }
    };
    const getDatabaseFacetList = () => {
        execFacetApi(String("dbname"));
    };
    const getCatyearFacetList = () => {
        execFacetApi(String("catyear"));
    };

    //検索実行
    const execFirstSearch = async () => {
        await search();
    };

    // 戻るボタンによる自動検索
    const firstSearch = () => {
        // vuex:state.paramsが他の画面の入力値の場合、破棄する
        if (store.state.params.url_name != "Top") {
            store.commit("resetParams");
        }
        // 元画面の入力値をvuex:state.paramsから取得
        const store_params = store.state.params;

        if (Object.keys(store_params).length > 0) {
            Object.entries(store_params).forEach(([key, value]) => {
                if (key == "sort") {
                    searchCondition.sort = value;
                } else if (key == "page") {
                    searchCondition.page = Number(value);
                } else if (key == "per_page") {
                    searchCondition.per_page = Number(value);
                } else if (key == "catyear") {
                    searchCondition.form[key] = value;
                    facetCatyear.showFacetCancel = true;
                } else if (key == "dbname") {
                    searchCondition.form[key] = value;
                    facetDatabase.showFacetCancel = true;
                } else if (key == "target_range") {
                    let targetAry = [];
                    for (let i = 0; i < value.length; i++) {
                        if (paramDefaults.target_range.includes(value[i])) {
                            targetAry.push(value[i]);
                        }
                    }
                    if (targetAry.length > 0) {
                        searchCondition.form.target_range = targetAry;
                    }
                    searchCondition.form[key] = value;
                } else if (key in searchCondition.form) {
                    searchCondition.form[key] = value;
                }
            });
            const scrollY = Number(store_params.scrollY || 0);
            formRef.value.validate((valid) => {
                if (valid) {
                    execFirstSearch();
                    // 検索完了後にスクロール位置を復元
                    if (scrollY > 0) {
                        const unwatch = watch(searchLoad, (newVal, oldVal) => {
                            if (oldVal === true && newVal === false) {
                                nextTick(() => {
                                    window.scrollTo(0, scrollY);
                                });
                                unwatch();
                            }
                        });
                    }
                } else {
                    return false;
                }
            });
        } else if (route.hash != "") {
            // URLのクエリパラメータに条件が記載されている場合
            let hashAry = route.hash.replace("#!/", "").split("/");
            let queryHash = {};
            for (let i = 0; i < hashAry.length; i++) {
                if (i % 2 === 0) {
                    if (!(hashAry[i] in queryHash)) {
                        queryHash[hashAry[i]] = "";
                    }
                } else {
                    if (
                        (hashAry[i - 1] == "target_range" ||
                            hashAry[i - 1] == "catyear" ||
                            hashAry[i - 1] == "dbname") &&
                        queryHash[hashAry[i - 1]] != ""
                    ) {
                        queryHash[hashAry[i - 1]] += ";;" + hashAry[i];
                    } else {
                        queryHash[hashAry[i - 1]] = hashAry[i];
                    }
                }
            }
            Object.entries(queryHash).forEach(([key, value]) => {
                if (key == "sort") {
                    searchCondition.sort = value;
                } else if (key == "page") {
                    searchCondition.page = Number(value);
                } else if (key == "per_page") {
                    searchCondition.per_page = Number(value);
                } else if (key == "target_range") {
                    let valueAry = value.split(";;");
                    let targetAry = [];
                    for (let i = 0; i < valueAry.length; i++) {
                        if (paramDefaults.target_range.includes(valueAry[i])) {
                            targetAry.push(valueAry[i]);
                        }
                    }
                    if (targetAry.length > 0) {
                        searchCondition.form.target_range = targetAry;
                    }
                } else if (key == "catyear" || key == "dbname") {
                    let valueAry = value.split(";;");
                    let targetAry = [];
                    for (let i = 0; i < valueAry.length; i++) {
                        targetAry.push(valueAry[i]);
                    }
                    searchCondition.form[key] = targetAry;
                    if (key == "catyear" && targetAry.length > 0) {
                        facetCatyear.showFacetCancel = true;
                    }
                    if (key == "dbname" && targetAry.length > 0) {
                        facetDatabase.showFacetCancel = true;
                    }
                } else if (key != "form_type" && key in searchCondition.form) {
                    searchCondition.form[key] = value;
                }
            });
            formRef.value.validate((valid) => {
                if (valid) {
                    execFirstSearch();
                } else {
                    return false;
                }
            });
        }
    };

    return {
        ...toRefs(searchCondition),
        ...toRefs(apiresult),
        paramDefaults,
        resetForm,
        search,
        firstSearch,
        showResult,
        searchLoad,
        searchError,
        formRef,
        searchInfoItems,
        searchParams,
        //ファセット用
        facetDatabase,
        getDatabaseFacetList,
        facetCatyear,
        getCatyearFacetList,
        facetResetFlg,
    };
};

export const SearchKey = Symbol("SearchContext");
